export const validatePassword = (password, confirmPassword, userId) => {
  const requirements = [
    { regex: /^.{8,}$/, message: "Måste vara minst 8 tecken långt" },
    { regex: /(?=.*[a-z])/, message: "Måste innehålla minst en liten bokstav" },
    { regex: /(?=.*[A-Z])/, message: "Måste innehålla minst en stor bokstav" },
    { regex: /(?=.*\d)/, message: "Måste innehålla minst en siffra" },
    { regex: /(?=.*[@$!%*?&])/, message: "Måste innehålla minst ett specialtecken (@$!%*?&)" },
  ];

  const invalidRequirements = requirements
    .filter((requirement) => !requirement.regex.test(password))
    .map((requirement) => `- ${requirement.message}`)
    .join("\n");

  if (password !== confirmPassword) {
    return "Lösenorden matchar inte.";
  }

  if (password.toLowerCase().includes(userId.toLowerCase())) {
    return "Lösenordet får inte innehålla användarnamnet.";
  }
  return invalidRequirements ? `Lösenordet uppfyller inte kraven:\n${invalidRequirements}` : null;
};
